import styled from 'styled-components';
import colors from '@theme/colors';

export const SidebarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  position: absolute;
  height: 100vh;
  max-height: 100vh;
  width: 73px;
  background: ${colors.INTENSIVE};
  padding-top: 193px;
  z-index: 2;
  opacity: 0.82;
  align-items: flex-start;
  padding-left: 23px;
  ${({ active }) =>
    active &&
    `
    width: 268px;
  `}
`;

export const SideButton = styled.button`
  padding: 0;
  outline: none;
  border: none;
  background-image: none;
  background-color: transparent;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  cursor: pointer;
  color: ${colors.TEAL_LIGHT};

  ${({ active }) =>
    active &&
    `
    color: inherit;
    pointer-events: none;
    cursor: default;
  `}
`;
export const ButtonText = styled.span`
  position: absolute;
  padding-top: 4px;
  display: flex-inline;
  display: inline-block;
  padding-left: 18px;
  font-size: 15px;
  font-weight: 500;
  text-align: left;
`;

export const SidebarEmail = styled.span`
  position: absolute;
  top: 145px;
`;

export const SidebarWhitespace = styled.span`
  display: inline-block;
  width: 24px;
  min-width: 24px;
  height: 24px;
  min-height: 24px;
`;



// WEBPACK FOOTER //
// ./components/layout/Sidebar.js